import Layout from 'components/Layout';
import Loading from 'components/Loading';
import { useAppSelector } from 'store/config';
import { useState, useEffect } from 'react';
import ModalFrame from 'components/modals/ModalFrame';
import ChildSuccess from 'components/modals/ChildSuccess';
import ChildFail from 'components/modals/ChildFail';
import Airdrop from 'components/Airdrop/Airdrop';

const airdrop = () => {
  const mintingResultLoading = useAppSelector(
    (state) => state.contract.isLoading,
  );
  const mintingResultDone = useAppSelector(
    (state) => state.contract.mintResult.isDone,
  );
  const mintingResultError = useAppSelector(
    (state) => state.contract.mintResult.isError,
  );
  const { tokenId, transactionHash, image } = useAppSelector(
    (state) => state.contract.mintResult,
  );

  const [mintingResultModalOpen, setMintingResultModalOpen] = useState(false);

  useEffect(() => {
    setMintingResultModalOpen(mintingResultDone || mintingResultError);
  }, [mintingResultLoading, mintingResultDone, mintingResultError]);

  useEffect(() => {
    if (!mintingResultModalOpen) return;
  }, [mintingResultModalOpen]);

  return (
    <>
      {mintingResultLoading && <Loading />}
      {mintingResultModalOpen && (
        <ModalFrame setOnModal={(bool) => setMintingResultModalOpen(bool)}>
          {!mintingResultError ? (
            <ChildSuccess
              tokenId={tokenId}
              transactionHash={transactionHash}
              image={image}
            />
          ) : (
            <ChildFail setOnModal={(bool) => setMintingResultModalOpen(bool)} />
          )}
        </ModalFrame>
      )}
      <Layout hideFooter>
        <Airdrop />
      </Layout>
    </>
  );
};

export default airdrop;
